import { render, staticRenderFns } from "./WhatsHappeningCurrentEntries.vue?vue&type=template&id=1d5c47de&"
import script from "./WhatsHappeningCurrentEntries.vue?vue&type=script&lang=js&"
export * from "./WhatsHappeningCurrentEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports